/// <amd-module name="SuiteCommerce.PhotoGallery.Common.Instrumentation.Helper"/>
define("SuiteCommerce.PhotoGallery.Common.Instrumentation.Helper", ["require", "exports", "SuiteCommerce.PhotoGallery.Instrumentation"], function (require, exports, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ComponentArea = 'SC Photo Gallery';
    var ExtensionVersion = '1.2.1';
    var QueueNameSuffix = '-PhotoGallery';
    var InstrumentationHelper = /** @class */ (function () {
        function InstrumentationHelper() {
        }
        InstrumentationHelper.initializeInstrumentation = function (container) {
            Instrumentation_1.default.initialize({
                environment: container.getComponent('Environment'),
                queueNameSuffix: QueueNameSuffix,
                defaultParameters: {
                    componentArea: ComponentArea,
                    extensionVersion: ExtensionVersion,
                },
            });
        };
        return InstrumentationHelper;
    }());
    exports.InstrumentationHelper = InstrumentationHelper;
});
